/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import Highlighter from 'react-highlight-words'
import { Link } from 'react-router-dom'

import { LIST_NAME as Announcementslist } from '../../assets/ts/data/announcements'
import { LIST_NAME as KnowledgeBaselist } from '../../assets/ts/data/knowledge-base'
import { LIST_NAME as QuestionAndAnswerlist } from '../../assets/ts/data/q-and-a'
import { openFile } from '../../assets/ts/files/files'
import { DocumentIconNames, removeTags } from '../../assets/ts/general/general'

interface InformationProps {
  activeClass?: string
  metaData: any
  page: any
  searchValue: string
}
const InformationPageList = ({ activeClass, metaData, page, searchValue }: InformationProps) => {
  const getListForPage = (page) => {
    if (page === 'Knowledgebase') {
      return KnowledgeBaselist
    } 
     if (page === 'Announcements') {
      return Announcementslist
    } 
     if (page === 'QuestionAndAnswer') {
      return QuestionAndAnswerlist
    }
  }
  return (
    <div
      className={`mb-2 pb-1 border-bottom1 ${activeClass}  ${page === 'Annoucements' ? 'kb' : ''}`}
    >
      <p className='m-0'>
        <Link
          className='title-color1 font-13 poppins-semibold  lineClamp1 maxfitcontent'
          title={metaData.title}
          to={metaData.link ? metaData.link : '#'}
        >
          <Highlighter
            highlightClassName='YourHighlightClass'
            searchWords={[searchValue]}
            textToHighlight={metaData.title}
          />
        </Link>
      </p>
      <p
        aria-label={metaData.content}
        className='m-0 py-1 lineClamp3 sourcesanspro font-13 title-color19 maxfitcontent'
        tabIndex={0}
      >
        <Highlighter
          highlightClassName='YourHighlightClass'
          searchWords={[searchValue]}
          textToHighlight={removeTags(metaData.content)}
        />
      </p>
      {metaData?.Attachments &&
        metaData?.Attachments[0]?.blobs.length > 0 &&
        metaData?.Attachments[0].blobs.map((blob) => (
          <a
            className='color-primary poppins-medium font-12 text-capitalize maxfitcontent'
            href='#'
            key={blob.fileName}
            onClick={() => openFile(blob, metaData.eKey, getListForPage(page))}
            tabIndex={0}
            title={blob.fileName}
          >
            <span className='color-primary'>
              <span className={`${DocumentIconNames(blob.fileName)} pe-2`}></span>
              <Highlighter
                highlightClassName='YourHighlightClass'
                searchWords={[searchValue]}
                textToHighlight={blob.fileName}
              />
            </span>
          </a>
        ))}
      {metaData.subcontent && (
        <p
          aria-label={metaData.subcontent}
          className='m-0 sourcesanspro subtitle-color2 font-13 maxfitcontent'
          tabIndex={0}
        >
          <Highlighter
            highlightClassName='YourHighlightClass'
            searchWords={[searchValue]}
            textToHighlight={metaData.subcontent}
          />
        </p>
      )}
      {metaData.subcontent1 && (
        <h3
          aria-label={metaData.subcontent}
          className='m-0 sourcesansprosemibold title-color2 font-13 maxfitcontent py-1 pb-0'
          tabIndex={0}
        >
          {metaData.subcontent1}
        </h3>
      )}
      {metaData.subcontent2 && (
        <p
          aria-label={metaData.content}
          className='m-0 py-1 lineClamp3 sourcesanspro font-13 title-color19 maxfitcontent'
          tabIndex={0}
        >
          {metaData.subcontent2}
        </p>
      )}
      {metaData.subcontent3 && (
        <p
          aria-label={metaData.content}
          className='m-0 py-1 lineClamp3 sourcesanspro font-13 title-color19 maxfitcontent'
          tabIndex={0}
        >
          {metaData.subcontent3}
        </p>
      )}
    </div>
  )
}
export default InformationPageList
